export function Spinner() {
  return (
    <div className="loadingSpinner"></div>
  );
}
